<template>
    <div class="copyright-apply">
        <xi-top></xi-top>
        <div class="sub-nav-wrapper">
            <div class="item active">
                <i class="icon icon-32 icon-flow-01"></i>
                <span class="">{{ $t('comb.accountRegister') }}</span>
            </div>
            <span>————————</span>
            <div class="item active">
                <i class="icon icon-32 icon-flow-02"></i>
                <span>填写资料</span>
            </div>
            <span class="grey">————————</span>
            <div class="item">
                <i class="icon icon-32 icon-prod-flow-03"></i>
                <span>等待审核</span>
            </div>
        </div>
        <div class="apply-wrapper">
            <el-tabs v-model="activeName" @tab-click="switchTabs">
                <el-tab-pane :disabled="userType===2" :label="$t('word.writer')" name="authorInfo">
                    <div class="form-wrapper">
                        <el-form :model="authorInfo" :rules="authorRules" ref="authorInfo" label-position="top">
                            <el-form-item :label="$t('comb.realName')" prop="name" :required="true">
                                <el-input size="large" v-model="authorInfo.name" :placeholder="$t('sen.realNamePlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.IDNumber')" prop="id" :required="true">
                                <el-input size="large" v-model="authorInfo.id" :placeholder="$t('sen.IDNumberPlaceHolder')">
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.phoneNumber')" prop="phoneNumber" :required="true">
                                <el-input size="large" v-model="authorInfo.phoneNumber" :placeholder="$t('sen.phoneNumberPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.emailAddress')" prop="email">
                                <el-input size="large" v-model="authorInfo.email" :placeholder="$t('sen.emailPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.address')" prop="address">
                                <el-input size="large" v-model="authorInfo.address" placeholder="您的联系地址"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('word.magnumOpus')" prop="curBook">
                                <el-input size="large" v-model="authorInfo.curBook" :placeholder="$t('sen.bookBelongPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('word.pseudonym')" prop="pseudonym">
                                <el-input size="large" v-model="authorInfo.pseudonym" :placeholder="$t('word.pseudonym')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('sen.uploadPictureWithLicence')" :required="true">
                                <label>{{ $t('sen.pictureUploadLimit') }}</label>
                            </el-form-item>
                            <el-form-item prop="idPic">
                                <el-upload action="/api/upload/file" type="drag" :show-file-list="false"
                                           :before-upload="uploadBefore" :multiple="false" :v-model="authorInfo.idPic"
                                           :on-success="uploadSuccess">
                                    <img v-if="authorInfo.idPic" :src="uploadedPic" alt="" class="wrapper-upload-large">
                                    <div v-else="authorInfo.idPic" class="wrapper-upload-large">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                                <el-card :body-style="{ padding: '0px' }">
                                    <img :src="`${IMG_HOST}example.png`">
                                </el-card>
                            </el-form-item>
                            <el-form-item prop="verifyCode">
                                <el-input :placeholder="$t('word.verifyCode')" v-model="authorInfo.verifyCode">
                                    <template slot="append"><img class="verify-code" :src="getVerifyCode" @click="getVerifyCodeSource"></template>
                                </el-input>
                            </el-form-item>
                            <el-form-item class="buttons">
                                <el-button type="primary" @click="nextStep('authorInfo')">{{ $t('comb.commitToAudit') }}</el-button>
                                <el-button type="text" @click="dialogVisible = true">{{ $t('word.cancel') }}</el-button>
                            </el-form-item>
                            <p style="margin: 30px 0;font-size: 12px; color: #ccc;">温馨提示：如果您在申请入驻时，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。
                                有声化平台官方邮箱：a.plus@ximalaya.com</p>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane :disabled="userType===1" :label="$t('comb.copyrightOrgnization')" name="publisherInfo">
                    <div class="form-wrapper">
                        <el-form :model="publisherInfo" :rules="publisherRules" ref="publisherInfo" label-position="top">
                            <el-form-item :label="$t('comb.publisherName')" prop="name" :required="true">
                                <el-input size="large" v-model="publisherInfo.name" :placeholder="$t('sen.publisherNameMissing')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.licenseNumber')" prop="id" :required="true">
                                <el-input size="large" v-model="publisherInfo.id" :placeholder="$t('sen.licenseNumberPlaceHolder')">
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.phoneNumber')" prop="phoneNumber" :required="true">
                                <el-input size="large" v-model="publisherInfo.phoneNumber" :placeholder="$t('sen.phoneNumberPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('word.magnumOpus')" prop="curBook">
                                <el-input size="large" v-model="publisherInfo.curBook" :placeholder="$t('sen.bookBelongPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.emailAddress')" prop="email">
                                <el-input size="large" v-model="publisherInfo.email" :placeholder="$t('sen.emailPlaceHolder')"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comb.address')" prop="address">
                                <el-input size="large" v-model="publisherInfo.address" placeholder="您的联系地址"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人" prop="pseudonym">
                                <el-input size="large" v-model="publisherInfo.pseudonym" placeholder="出版社的联络人"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人电话" prop="contacterPhoneNumber">
                                <el-input size="large" v-model="publisherInfo.contacterPhoneNumber" placeholder="联系人电话"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('sen.uploadLicensePic')" :required="true">
                                <label>{{ $t('sen.pictureUploadLimit') }}</label>
                            </el-form-item>
                            <el-form-item prop="idPic">
                                <el-upload action="/api/upload/file" type="drag" :show-file-list="false"
                                           :before-upload="uploadBefore" :multiple="false" :v-model="publisherInfo.idPic"
                                           accept=".jpg, .png, .bmp"
                                           :on-success="uploadSuccess">
                                    <img v-if="publisherInfo.idPic" :src="uploadedPic" alt="" class="wrapper-upload-large">
                                    <div v-else="publisherInfo.idPic" class="wrapper-upload-large">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                            </el-form-item>
                            <el-form-item prop="verifyCode">
                                <el-input :placeholder="$t('word.verifyCode')" v-model="publisherInfo.verifyCode">
                                    <template slot="append"><img class="verify-code" :src="getVerifyCode" @click="getVerifyCodeSource"></template>
                                </el-input>
                            </el-form-item>
                            <el-form-item class="buttons">
                                <el-button type="primary" @click="nextStep('publisherInfo')">{{ $t('comb.commitToAudit') }}</el-button>
                                <el-button type="text" @click="dialogVisible = true">{{ $t('word.cancel') }}</el-button>
                            </el-form-item>
                            <p style="margin: 30px 0;font-size: 12px; color: #ccc;">温馨提示：如果您在申请入驻时，有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务。
                                有声化平台官方邮箱：a.plus@ximalaya.com</p>
                        </el-form>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <xi-footer></xi-footer>
        <el-dialog :title="`${ $i18n.t('word.tips') }`" v-model="dialogVisible" size="tiny">
            <span>{{ $t('sen.backToPrevPageConfirm') }}?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t('word.cancel') }}</el-button>
                <el-button type="primary" @click="goBack">{{ $t('word.ok') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>r
<script>
  import XiFooter from '../components/Footer.vue';
  import XiTop from '../components/Top.vue';
  import axios from 'axios';
  export default {
    data() {
      // 自定义验证规则
//      let checkAuthorID = (rule, value, callback) => {
//        if (!value) {
//          return callback(new Error(this.$i18n.t('sen.keyInYourIDNumber')));
//        } else {
//          let reg = new RegExp(/^[1-9]{1}\d{14}$|^[1-9]{1}\d{16}(\d|[xX])$/);
//          if (!reg.test(value)) {
//            callback(new Error(this.$i18n.t('sen.errorInIDNumber')));
//          } else {
//            callback();
//          }
//        }
//      };
      let checkPublisherID = (rule, value, callback) => {
        if (!value) {
          return callback(new Error(this.$i18n.t('sen.licenseNumberPlaceHolder')));
        } else {
          callback();
        }
      };
      let checkChineseOnly = (rule, value, callback) => {
        const reg = new RegExp('^[a-zA-Z|\\u4e00-\\u9fa5]{0,}$');
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error(this.$i18n.t('sen.wordOnlyInName')));
        }
      };
      let checkXSS = (rule, value, callback) => {
        const reg = new RegExp('(<.*\/>)|(<.*>.*<\/.*>)');
        if (reg.test(value)) {
          callback(new Error('你输入的内容违规！'));
        } else {
          callback();
        }
      }
      return {
        activeName: '',
        curBook: '',
        dialogVisible: false,
        publisherInfo: {
          email: '',
          curBook: '',
          name: '',
          id: '',
          idPic: '',
          phoneNumber: '',
          verifyCode: '',
          address: '',
          pseudonym: '',
          contacterPhoneNumber: ''
        },
        authorInfo: {
          email: '',
          curBook: '',
          pseudonym: '',
          name: '',
          id: '',
          idPic: '',
          phoneNumber: '',
          verifyCode: '',
          address: ''
        },
        verifyCodeSource: '',
        userType: 0,
        authorRules: {
          name: [
            {required: true, message: this.$i18n.t('sen.publisherNameMissing'), trigger: 'blur'},
            { validator: checkChineseOnly, trigger: 'blur' },
            { max: 50, message: this.$i18n.t('sen.workNameLengthShouldLessThanFifty')},
            { validator: checkXSS, trigger: 'blur'}
          ],
          id: [
            {max: 100, message: this.$i18n.t('sen.errorInIDNumber'), trigger: 'blur'},
            {required: true, message: '请输入您的身份证号码', trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          phoneNumber: [
            {required: true, message: this.$i18n.t('sen.phoneNumberPlaceHolder'), trigger: 'blur'},
            {max: 20, message: '电话号码长度应当在20位之内', trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          email: [
            {type: 'email', message: this.$i18n.t('sen.syntaxErrorOfEmailAddress'), trigger: 'blur'},
            { max: 150, message: this.$i18n.t('sen.emailAddressLengthShouldLessThanOneFifty')},
            { validator: checkXSS, trigger: 'blur'}
          ],
          address: [
            { max: 150, message: '联系地址长度不能大于150个字符'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          curBook: [
            { max: 150, message: '书单不能大于150个字符'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          pseudonym: [
            { max: 50, message: '笔名不能大于150个字符'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          idPic: [
            {required: true, message: this.$i18n.t('sen.uploadLicensePic'), trigger: 'change'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          verifyCode: [
            {required: true, message: this.$i18n.t('sen.verifyCodeMissing'), trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ]
        },
        publisherRules: {
          name: [
            {required: true, message: this.$i18n.t('sen.publisherNameMissing'), trigger: 'blur'},
            { validator: checkChineseOnly, trigger: 'blur' },
            { max: 50, message: this.$i18n.t('sen.workNameLengthShouldLessThanFifty')},
            { validator: checkXSS, trigger: 'blur'}
          ],
          id: [
            {validator: checkPublisherID, trigger: 'blur'},
            { max: 150, message:'工商注册号码不能大于150个字符'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          pseudonym: [
            { validator: checkXSS, trigger: 'blur'}
          ],
          address: [
            { validator: checkXSS, trigger: 'blur'}
          ],
          phoneNumber: [
            {required: true, message: this.$i18n.t('sen.phoneNumberPlaceHolder'), trigger: 'blur'},
            {max: 20, message: '电话号码长度应当在20位之内', trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          curBook: [
            { max: 150, message: '书单不能大于150个字符'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          contacterPhoneNumber: [
            {max: 20, message: '电话号码长度应当在20位之内', trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          email: [
            {type: 'email', message: this.$i18n.t('sen.syntaxErrorOfEmailAddress'), trigger: 'blur'},
            { max: 150, message: this.$i18n.t('sen.emailAddressLengthShouldLessThanOneFifty')},
            { validator: checkXSS, trigger: 'blur'}
          ],
          idPic: [
            {required: true, message: this.$i18n.t('sen.uploadLicensePic'), trigger: 'change'},
            { validator: checkXSS, trigger: 'blur'}
          ],
          verifyCode: [
            {required: true, message: this.$i18n.t('sen.verifyCodeMissing'), trigger: 'blur'},
            { validator: checkXSS, trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      },
      getVerifyCode () {
        return 'data:image/png;base64,' + this.verifyCodeSource;
      },
      uploadedPic() {
        return this.$store.state.UPLOAD_IMG_HOST+this[this.activeName].idPic;
      },
    },
    methods: {
      switchTabs (tab, event) {
        this.activeName = tab.name;
      },
      getBaseInfo() {
        const that = this;
        axios.get('/api/settle/info').then(res => {
          // 成功
          if (res.data.code === 200) {
            var result = res.data.data;
            if (result) {
              that.userType = result.authorType === 'press'? 2: 1;
              that.activeName = that.userType===2? 'publisherInfo': 'authorInfo';
              const form = that.activeName;
              that[form].name = result.name;
              that[form].id = result.authorApply.certificateNumber;
              that[form].idPic = result.authorApply.certificateImage;
              that[form].curBook = result.bookList;
              that[form].phoneNumber = result.phoneNumber;
              that[form].email = result.email;
              that[form].pseudonym = result.pseudonym;
              that[form].address = result.address;
              that[form].contacterPhoneNumber = result.phoneNumber2;
            } else {
              that.activeName = 'authorInfo';
            }
          }
        });
      },
      uploadSuccess (response, file, fileList) {
        const form = this.activeName;
        this[form].idPic = response.data;
      },
      goBack() {
        this.dialogVisible = false;
        this.$router.go(-1);
      },
      nextStep (form) {
        const that = this;
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              name: that[form].name,
              pseudonym: that[form].pseudonym,
              certificateNumber: that[form].id,
              certificateImage: that[form].idPic,
              phoneNumber: that[form].phoneNumber,
              email: that[form].email,
              bookList: that[form].curBook,
              authorType: that.userType === 0? (form ==='authorInfo'? 1: 2):that[form].userType,
              verifyCode: that[form].verifyCode,
              address: that[form].address,
              phoneNumber2: that[form].contacterPhoneNumber
            };
            axios.post('/api/settle/apply', data).then(res => {
              if (res.data.code === 200) {
                this.$store.dispatch('getStatus');
                this.$router.push({name: 'copyrighterApplyWaiting'});
              } else if(res.data.code === 1003) {
                this.$message({
                  type: 'warning',
                  message: res.data.message,
                  duration: 1500
                });
                this.getVerifyCodeSource();
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.message,
                  duration: 1500
                });
              }
            });
          } else {
            this.$message({
              type: 'error',
              message: this.$i18n.t('sen.infoErrorRecommitPlease'),
              duration: 1000
            });
            return false;
          }
        });
      },
      uploadBefore (file) {
        console.log('file.size: ', file.size);
        // 限制文件大小 (大图标5M以下)
        if (parseInt(file.size) > 5000 * 1024) {
          this.$message.error(this.$i18n.t('sen.bigIconSizeLimit'))
          return false
        }

        this.loading = 1;
        try {
          this.previewPic = URL.createObjectURL(file)
        } catch (err) {
          this.previewPic = false;
          console.log('URL.createObjectURL', err)
        }
      },
      getVerifyCodeSource () {
        axios.get('/api/settle/verifyCode').then( res => {
          this.verifyCodeSource = res.data;
        });
      }
    },
    components: {
      axios,
      XiFooter,
      XiTop
    },
    beforeMount () {
      this.getBaseInfo();
      this.getVerifyCodeSource();
    }
  }

</script>
<style lang="sass">
    @import "../../sass/copyright/apply.scss";
</style>



// WEBPACK FOOTER //
// Apply.vue?da02e714